import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { ItemMaster, ItemMasterFilter } from '@app/models/item/item-master/item-master';
import { ItemMasterGreigeSearchCommand } from '@app/models/item/item-master/item-master';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class ItemMasterProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/item';

  public getItemMastersForGreigeCodes(
    itemMasterGreigeSearchCommand: ItemMasterGreigeSearchCommand[],
  ): Observable<ApiResponse<Record<string, ItemMaster | null>>> {
    return this.httpClient.post<ApiResponse<Record<string, ItemMaster | null>>>(
      `${this.baseUrl}/greige-base-code/batch`,
      itemMasterGreigeSearchCommand,
    );
  }

  public search(filter: ItemMasterFilter): Observable<ApiResponse<PaginatedApiResponse<ItemMaster>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ItemMaster>>>(`${this.baseUrl}/search`, filter);
  }

  public getByItemCodes(itemCodes: string[]): Observable<ApiResponse<ItemMaster[]>> {
    return this.httpClient.post<ApiResponse<ItemMaster[]>>(`${this.baseUrl}/item-codes/batch`, { itemCodes });
  }
}
